import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appNumericInput]',
})
export class NumericInputDirective {
  @Input() allowDecimals = false;

  private FORMAT_REGEX_DEFAULT = /^\d{0,15}?$/;
  private FORMAT_REGEX_DECIMAL = /^\d{0,15}(\.\d{0,4})?$/;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    let value = inputElement.value;

    const validRegex = this.allowDecimals
      ? this.FORMAT_REGEX_DECIMAL
      : this.FORMAT_REGEX_DEFAULT;

    let sanitizedValue = value.replace(/[^0-9.]/g, '');

    if (this.allowDecimals) {
      const parts = sanitizedValue.split('.');
      if (parts.length > 2) {
        sanitizedValue = parts[0] + '.' + parts.slice(1).join('');
      }
    }

    if (!validRegex.test(sanitizedValue)) {
      sanitizedValue = this.allowDecimals
        ? sanitizedValue.replace(/(\.\d{4}).*/, '$1')
        : sanitizedValue.replace(/\D/g, '');
      sanitizedValue = sanitizedValue.slice(0, 15);
    }

    inputElement.value = sanitizedValue;
  }
}
